import { forwardRef } from "react"
import { StyledModal } from "./styled"
import { IModalProps } from "./types"
import { Grid, IconButton, Typography, Paper } from "src/lib"
import { AutoAwesome, Close } from "@mui/icons-material"

const Modal = forwardRef<HTMLDivElement, IModalProps>(
    ({ children, title, onClickAIButton, onClose, size = "md", ...props }, ref) => {
        return (
            <StyledModal ref={ref} size={size} onClose={onClose} {...props}>
                <Paper>
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="flex-start"
                        wrap="nowrap"
                        gap={1}
                    >
                        <Grid item sx={{ minWidth: 0 }}>
                            <Grid container gap={1.5} alignItems="center" wrap="nowrap">
                                <Typography variant="h4">{title}</Typography>
                                {onClickAIButton && (
                                    <IconButton color="primary" onClick={onClickAIButton}>
                                        <AutoAwesome />
                                    </IconButton>
                                )}
                            </Grid>
                        </Grid>
                        <IconButton variant="clean" color="neutral" onClick={onClose}>
                            <Close />
                        </IconButton>
                    </Grid>
                    <Grid sx={{ mt: 2 }}>{children}</Grid>
                </Paper>
            </StyledModal>
        )
    }
)

export { Modal }